import { SchemaModelFieldType, StoreSimpleListType } from '@smx-ui-model/types';
import { Form, Select } from 'antd';
import * as React from 'react';

import { storeSimpleList } from '../store-simple-list';

interface FieldSimpleListProps {
    listName: keyof StoreSimpleListType;
    schemaField: SchemaModelFieldType;
    message?: string;
}

export const FieldSimpleList: React.FC<FieldSimpleListProps> = ({ listName, schemaField, message }) => {
    console.log(schemaField);
    const simpleList = storeSimpleList[listName];

    return (
        <Form.Item
            name={schemaField.name}
            label={schemaField.title}
            rules={[{ required: schemaField.isRequired, message: message || 'Fill out data' }]}
        >
            <Select allowClear>
                {simpleList.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                        {item.value}
                    </Select.Option>
                ))}
            </Select>
        </Form.Item>
    );
};
